import UnderConstruction from '../components/UnderConstruction';

export default function Gear() {
  return <UnderConstruction pageName="Armory" />;
}
